import { MapPin, Navigation } from "lucide-react";
import { Chapter, Reveal } from "./shared";

const AREAS = [
  "São Paulo (Capital)",
  "Guarulhos",
  "Grande ABC",
  "Zona Norte",
  "Zona Sul",
  "Zona Leste",
  "Zona Oeste",
  "Vale do Paraíba",
];

const MAPS_URL =
  "https://www.google.com/maps/place/Manutentudo+servi%C3%A7os+De+g%C3%A1s/@-23.4513204,-46.3636845,17z/data=!4m6!3m5!1s0x94ce63e94a48e26d:0x47b56036f7a8565e!8m2!3d-23.4513204!4d-46.3636845!16s%2Fg%2F11h2q5k2bb";

export const Coverage = () => (
  <section className="bg-white py-24 sm:py-32" data-testid="coverage-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Chapter num="07 — Cobertura" title="Atendemos toda" accent="São Paulo e região" />
      <Reveal className="-mt-8 mb-12 text-center">
        <p className="text-base text-zinc-500 sm:text-lg" data-testid="coverage-tagline">
          Chegamos até você com <b className="text-zinc-800">agilidade, preço justo e atenção aos detalhes</b>
        </p>
      </Reveal>
      <div className="grid items-center gap-12 lg:grid-cols-2">
        <Reveal>
          <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2" data-testid="coverage-list">
            {AREAS.map((a) => (
              <li key={a} className="flex items-center gap-3 text-base font-medium text-zinc-800">
                <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--primary)]/15">
                  <MapPin size={15} className="text-[#E8A200]" />
                </span>
                {a}
              </li>
            ))}
          </ul>
          <div className="mt-8 rounded-2xl border border-zinc-200 bg-zinc-50 p-5" data-testid="coverage-address">
            <p className="flex items-start gap-3 text-sm text-zinc-600">
              <MapPin size={17} className="mt-0.5 shrink-0 text-[#E8A200]" />
              <span>
                <b className="text-zinc-900">R. Rodeio Bonito, 29</b> - Jardim Coqueiro,
                Itaquaquecetuba - SP, 08582-630
              </span>
            </p>
            <a
              href={MAPS_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="coverage-directions-button"
              className="mt-4 inline-flex items-center gap-2 rounded-full bg-[var(--primary)] px-5 py-2.5 font-display text-sm font-bold uppercase tracking-wider text-black transition-transform duration-300 hover:scale-105"
            >
              <Navigation size={14} />
              Como chegar
            </a>
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="overflow-hidden rounded-3xl border border-zinc-200 shadow-xl" data-testid="coverage-map">
            <iframe
              title="Localização da Manutentudo Serviços no Google Maps"
              src="https://maps.google.com/maps?cid=5167141936677017182&hl=pt-BR&z=16&output=embed"
              className="h-[380px] w-full"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              data-testid="coverage-map-iframe"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
